import { ActionTypes } from '../actionTypes'
import { MailMag, MailMagTypes } from './types'

const initialState: MailMag = {
  memberId: '',
  mail: '',
}

export const MailMagReducer = (
  state = initialState,
  action: MailMagTypes
): MailMag => {
  switch (action.type) {
    case ActionTypes.mailMag:
      return {
        ...state,
        memberId: action.payload.memberId,
        mail: action.payload.mail,
      }
    default:
      return state
  }
}
